export const refs = {
  categories: document.querySelector('.categories-list'),
  furnitureList: document.querySelector('.furniture-list'),
  loadMoreBtn: document.querySelector('.load-more'),
  loader: document.querySelector('.loader'),
  section: document.querySelector('[data-feedback-section]'),
  loaderFeedback: document.querySelector('[data-feedback-loader]'),
  readyState: document.querySelector('[data-feedback-ready]'),
  list: document.querySelector('[data-feedback-list]'),
  prevBtn: document.querySelector('[data-feedback-prev]'),
  nextBtn: document.querySelector('[data-feedback-next]'),
  pagination: document.querySelector('[data-feedback-pagination]'),
  backdrop: document.querySelector('.backdrop'),
  modalCloseBtn: document.querySelector('.product-close-btn'),
  modalContainer: document.querySelector('.product-modal'),
  orderBtn: document.querySelector('.order-btn'),
  productModal: document.querySelector('#product-backdrop'),
  orderModal: document.querySelector('#order-backdrop'),
  orderForm: document.querySelector('#order-form-id'),
  orderCloseBtn: document.querySelector('.order-close-btn'),
  submitBtn: document.querySelector('.submit-btn'),
  thanksModal: document.querySelector('#thanks-backdrop'),
  thanksCloseBtn: document.querySelector('.thanks-close-btn-js'),
  thanksCloseCross: document.querySelector('.thanks-close-btn-js'),
  thanksCloseBtn: document.querySelector('.close-thanks-modal-btn'),
};
